import React from "react";

function GanttIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 24.769 23">
      <rect
        width="24.769"
        height="3.538"
        rx="1"
        transform="translate(0 2.947)"
      />
      <rect
        width="17.692"
        height="3.538"
        rx="1"
        transform="translate(0 7.665)"
      />
      <rect
        width="24.769"
        height="3.538"
        rx="1"
        transform="translate(0 12.384)"
      />
      <path
        d="M.727,0H10.911a.818.818,0,0,1,.727.885V2.654a.818.818,0,0,1-.727.885H.727A.818.818,0,0,1,0,2.654V.885A.818.818,0,0,1,.727,0Z"
        transform="translate(0 17.103)"
      />
      <line
        y2="23"
        transform="translate(4.453 0)"
        fill="none"
        stroke="#EDEDED"
        strokeWidth="1"
      />
    </svg>
  );
}

export { GanttIcon };
